<template>
<span>
<p>Inhalt der Leistung:</p>

<ul>
  <li>
    <p>Vergleich der Dokumente der Planungsunterlagen mit dem installierten Blitzschutzsystem vor Ort</p>
  </li>
  <li>
    <p>Erstellung einer Ausf&uuml;hrungsdokumentation</p>
  </li>
</ul>

<p><span style="font-size:9pt"><em>Hinweis: </em></span><span style="font-size:9pt"><em>Die Abnahme des Blitzschutzes wird nur bei von uns durchgef&uuml;hrten Planungen &uuml;bernommen.</em></span></p>

<p><span style="font-size:9pt"><em>Bei der Abnahme handelt es sich nur um eine textliche Beschreibung und nicht um ein Gutachten!</em></span></p>

</span>
</template>

<script>
export default {
  name: "TooltipAbnahmeBlitzschutz"
}
</script>

<style scoped>

</style>
